<template>
  <div class="bread-panel">
    <el-breadcrumb  separator-class="el-icon-arrow-right">
<!--      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
<!--      <el-breadcrumb-item>活动管理</el-breadcrumb-item>-->
<!--      <el-breadcrumb-item>活动列表</el-breadcrumb-item>-->
      <el-breadcrumb-item>
        <div class="el-breadcrumb-item-in">
<!--          <img :src="config.icon" alt="">-->
          <span class="name">面包屑</span>
        </div>

      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: "topBreadcrumb",
  props:{
    config:{
      type:Object,
      value:()=>{
        return {
          name:'111',
          icon:''
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bread-panel{
  width: 100%;
  height: 35px;
  background: #FFFFFF;
  box-shadow: 0vw 0vw 0.677vw 0vw rgba(255, 218, 225, 0.2);
  display: flex;
  align-items: center;
  .el-breadcrumb{
    margin-left: 20px;
    .el-breadcrumb__item{
      .el-breadcrumb-item-in{
        display: flex;
        align-items: center;
        img{
          width: 1.042vw;
          height: 1.042vw;
          margin-right: 0.521vw;
        }
        .name{
          font-size: 12px;
          font-family: PingFangSC;
          font-weight: bold;
          color: #333333;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/topBreadcrumb.vue